import setGrabCursor from './setGrabCursor.js';
import unsetGrabCursor from './unsetGrabCursor.js';
export default {
  setGrabCursor,
  unsetGrabCursor
};


//////////////////
// WEBPACK FOOTER
// /Users/guillaumeluce/Documents/ocean/web/app/themes/akyos-sage/node_modules/swiper/core/grab-cursor/index.js
// module id = 64
// module chunks = 0